/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// require('./bootstrap');

// require('./base');
import Vue from "vue";
import vuedraggable from "vuedraggable";

let ArtefactSelect = require("../vue/artefact-select.vue");
let ArtefactSelectList = require("../vue/artefact-select-list.vue");
let EditorPreview = require("../vue/editor-preview.vue");
let ImageModal = require("../vue/image-modal.vue");
let ImageCropper = require("../vue/image-cropper.vue");
let StoryVisitingPointCreator = require("../vue/story-visiting-point-creator.vue");
let BuildingVisitingPointCreator = require("../vue/building-visiting-point-creator.vue");
let i18nText = require("../vue/@components/i18n-text.vue");
let i18nTextarea = require("../vue/@components/i18n-textarea.vue");
let brandLocationCreator = require("../vue/brand-location-creator.vue");

let app = new Vue({
    el: "#app",
    components: {
        "artefact-select": ArtefactSelect,
        "artefact-select-list": ArtefactSelectList,
        "editor-preview": EditorPreview,
        "image-modal": ImageModal,
        "image-cropper": ImageCropper,
        "story-visiting-point-creator": StoryVisitingPointCreator,
        "building-visiting-point-creator": BuildingVisitingPointCreator,
        "i18n-text": i18nText,
        "i18n-textarea": i18nTextarea,
        "brand-location-creator": brandLocationCreator
    }
});



// WEBPACK FOOTER //
// ./resources/js/app.js